<template>
  <ul class="datagrid list-group">
    <slot></slot>
    <li class="datagrid-item list-group-item" v-for="(item, index) in articleList" :key="index">
      <a href="javascript:void(0);" class="item__box" @click="onItemClick(item)">
        <span class="tag">{{item.copyright}}</span>
        <span class="title">{{item.title}}</span>
        <span class="date">{{item.auditDate}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    articleList: {
      type: Array,
      default: []
    }
  },
  methods: {
    onItemClick (item) {
      this.$emit('on-item-click', item)
    }
  }
}
</script>

<style type="text/css" lang="stylus" scoped>
@import '../../stylus/mixin'
.datagrid
  margin 0
  color #1a4369
  list-style-type none
  border-radius 0
  display table-cell
  font-size 0
  .datagrid-item
    width 50%
    font-size 14px
    float left
    border none
    // margin 1px 0
    background-color transparent
    &:first-child
      border-top-left-radius 0
      border-top-right-radius 0
    &:last-child
      border-bottom-left-radius 0
      border-bottom-right-radius 0
    &:nth-child(odd)
      border-top none
      // border-right 2px dotted #2D5275
      background-image url("/static/img/dotted.png")
      background-repeat repeat-y
      background-position right top
    .item__box
      display block
      color #333
      text-decoration none
      font-size 0
      span
        vertical-align middle
        display inline-block
        font-size 14px
        line-height 20px
    .tag
      margin-right 20px
    .title
      max-width 394px
      ellipsis()
    .date
      float right
    .item__box:hover
      color rgb(82, 210, 255)
</style>



// WEBPACK FOOTER //
// datagrid.vue?3ab3e28f